import { render, staticRenderFns } from "./webAICase.vue?vue&type=template&id=4055c7ea&scoped=true&"
import script from "./webAICase.vue?vue&type=script&lang=js&"
export * from "./webAICase.vue?vue&type=script&lang=js&"
import style0 from "./webAICase.vue?vue&type=style&index=0&id=4055c7ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4055c7ea",
  null
  
)

export default component.exports